import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import { api, BACKEND_URL } from "../lib/api";
import { IMAGES } from "../lib/data";

const ContentCtx = createContext(null);
export const useContent = () => useContext(ContentCtx);

// Résout une valeur d'image : URL absolue / asset local -> tel quel ; sinon préfixe le backend
export const resolveImg = (v) => {
  if (!v) return "";
  return v.startsWith("http") || v.startsWith("/assets") ? v : `${BACKEND_URL}${v}`;
};

export function ContentProvider({ children }) {
  const [texts, setTexts] = useState({});
  const [imagesRaw, setImagesRaw] = useState({});
  const [videosRaw, setVideosRaw] = useState({});

  const refresh = useCallback(() => {
    api.get("/content")
      .then((r) => {
        setTexts(r.data?.texts || {});
        setImagesRaw(r.data?.images || {});
        setVideosRaw(r.data?.videos || {});
      })
      .catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Fusionne les images par défaut avec les surcharges admin (mêmes clés que data.js IMAGES)
  const images = useMemo(() => {
    const merged = { ...IMAGES };
    for (const [k, v] of Object.entries(imagesRaw || {})) {
      if (v) merged[k] = resolveImg(v);
    }
    return merged;
  }, [imagesRaw]);

  return (
    <ContentCtx.Provider value={{ texts, images, imagesRaw, videosRaw, refresh }}>
      {children}
    </ContentCtx.Provider>
  );
}

// Hook pratique : renvoie la map d'images fusionnée (surcharges admin incluses)
export const useImages = () => useContent()?.images || IMAGES;
export const useVideos = () => {
  const raw = useContent()?.videosRaw || {};
  return raw;
};
